<template>
  <div v-loading="loading" v-if="question.isShow" class="question-item">

    <div class="question-title">
      <i v-if="question.isMust">*</i><span>第{{ question.serialNumber }}题目</span>{{ question.title }}
    </div>
    <div v-if="question.note" class="question-note">说明：{{ question.note }}</div>
    <div class="qs-img-preview">
      <img :src="question.pictureUrl" alt="">
    </div>
    <div :class="{'option-container':true, 'flex': question.optionLayout == 3 ||question.optionLayout == 2 }">

      <div :class="{'question-option':true, 'three': question.optionLayout == 3,'two': question.optionLayout == 2}"
           v-for="(item,index) in question.options" :key="index">
        <div class="question-option-container">
          <div style="display:flex;align-items: center">
            <div @click="selectHandler(item,index)" class="option-title">
              <i v-if="item.disabled" class="disabled iconfont iconcheck_box_px_rounded"></i>
              <i v-else>
                <i v-if="!item.selected" class="iconfont iconcheckboxoutlineblank"></i>
                <i v-else class="iconfont iconcheck_box_px_rounded"></i>
              </i>
              <span :class="{active: item.selected}">{{ item.optionTitle }}</span>
            </div>
            <i v-if="item.selected && item.isExtension" @click="showHandler(item,index)"
               :class="{'el-icon-edit': true,'red': false,'yellow': item.answerExport.indexOf('?') != -1}"></i>
          </div>
          <div class="option-other">
            <!-- <input @change="saveAnswer()" type="text" v-model="item.fillContent"
                   v-if="item.allowFill && item.selected"> -->
            <textarea  type="text" v-model="item.fillContent" class="fill-content"
                       v-if="item.allowFill && item.selected"></textarea>
            <!--<input type="file" v-if="item.allowUpload && item.selected">-->
            <div style="display: flex;align-items: center;" v-if="item.showTime && item.selected">
              <time-picker  :date="item"></time-picker>
              <!--<input @change="saveAnswer()" v-model="item.yearSelect" type="text">年-->
              <!--<input @change="saveAnswer()" v-model="item.monthSelect" type="text">月-->
              <!--<input @change="saveAnswer()" v-model="item.daySelect" type="text">日-->
            </div>
          </div>
          <div style="font-size: 14px;margin: 10px 0;color:#248cfa;" v-if="item.selected && item.answerExport">{{ item.answerExport }}</div>
        </div>
      </div>
    </div>
    <el-dialog
        :title=" item && item.optionExtra.extraTitle"
        :visible.sync="extraGroupVisible"
        width="60%">
      <div v-if="extraGroupVisible" class="extra-content">
        <div
            style="width: 100%;display: flex;justify-content: space-between;align-items: center;padding: 10px;border-radius: 5px; border: 1px solid #248cfa;margin-bottom: 10px;"
            v-for="(it,ind) in item.optionExtra.optionGroupList" :key="it.id">
          <div style="width: 90%;">
            <div class="extra-content-inner">
              <div v-for="(outGroup,outIndex) in it.optionExtraWithOutGroupArr" :key="outIndex">
                <completion :item="outGroup" v-if="outGroup.type == 1"></completion>
                <dropDown :contentList="item.contentList" :item="outGroup"
                          v-if="outGroup.type == 2 && item.contentList"></dropDown>
                <dateTime :item="outGroup"
                          v-else-if="outGroup.type == 3 || outGroup.type == 4 || outGroup.type == 5 || outGroup.type == 6 || outGroup.type == 7"></dateTime>
              </div>
            </div>
            <div>
              <div class="extra-content-inner" v-for="(inGroup,inIndex) in it.optionExtraGroupArr" :key="inGroup.id">
                <div class="extra-content-inner-item" v-for="(inGroupItem,inItemIndex) in inGroup.arr"
                     :key="inItemIndex">
                  <completion :item="inGroupItem" v-if="inGroupItem.type == 1"></completion>
                  <dropDown :contentList="item.contentList" :item="inGroupItem"
                            v-if="inGroupItem.type == 2 && item.contentList"></dropDown>
                  <dateTime :item="inGroupItem"
                            v-else-if="inGroupItem.type == 3 || inGroupItem.type == 4 || inGroupItem.type == 5 || inGroupItem.type == 6 || inGroupItem.type == 7"></dateTime>
                </div>
                <i @click="addGroupItemHandler(it,inGroup,item)" class="el-icon-circle-plus"></i>
                <i v-if="it.optionExtraGroupArr.length != 1" @click="deleteGroupItemHandler(it,item,inIndex)"
                   class="el-icon-delete"></i>
              </div>
            </div>
          </div>
          <div style="width: 10%;display: flex;justify-content: space-around;">
            <i @click="addOutGroup(it,item)" class="el-icon-circle-plus" style="font-size: 23px"></i>
            <i v-if="item.optionExtra.optionGroupList.length != 1" @click="deleteOutGroup(it,item,ind)"
               class="el-icon-delete-solid" style="font-size: 23px"></i>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirmHandler">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>


<script>
import timePicker from "../../timePicker";
import {mapGetters} from "vuex";
import _ from "lodash";
import dropDown from './extraQuestion/dropDown'
import dateTime from './extraQuestion/dateTime'
import completion from "./extraQuestion/completion";
export default {
  name: 'question-Multiple',
  props: {
    question: {required: true},
    displaySetting: {required: true},
    jumpSetting: {required: true},
    questionList: {required: true},
    patientId: {required: true}

  },
  data() {
    return {
      optionInfoId: '',
      item: null,
      extraGroupVisible: false,
      loading: false,
      currentIndexList: [],
      show: false
    }
  },
  computed: {
    QsValue() {
      return this.question.options.filter(item => item.selected)
    },
    ...mapGetters([
      'currentPage'
    ])
  },
  components: {timePicker, dropDown, dateTime, completion},
  // beforeDestroy() {
  //   console.log(this.currentPage, this.question.pageNumber);
  //   if (this.$route.path == '/callPatient' && this.currentPage == this.question.pageNumber) {
  //     console.log('destory');
  //     this.deleteAnswer()
  //     this.question.options.map((item, index) => {
  //       item.selected = false
  //       item.disabled = false
  //       this.disabledShowOrHide(index + 1, false)
  //     })
  //   }
  // },
  created() {
    this.getAnswer()
    this.getPicture()
  },
  watch: {
    // 'question.isShow': {
    //   handler(val, oldVal) {
    //     if (!val && oldVal) {
    //       this.question.options.map((item, index) => {
    //         item.selected = false
    //         item.disabled = false
    //         this.disabledShowOrHide(index + 1, false)
    //       })
    //       this.deleteAnswer()
    //     }
    //   },
    //   deep: true,
    //   immediate: true
    // },

  },
  methods: {
    async queryQuestionnaireOptionListByTagId(p) {
      let result = await this.$store.dispatch('requestHandler', {
        fn: 'RestNewQuestionnaireDesignCallcenterControllerQueryQuestionnaireOptionListByTagId',
        params: {
          tagIds: p.tagIds
        }
      })
      return result
    },
    confirmHandler() {
      this.saveExtraQuestionHandler({
        optionInfoId: this.optionInfoId,
        followupTaskId: localStorage.getItem('taskId'),
        followupPatientId: this.patientId,
        answerInfo: JSON.stringify(this.item.optionExtra)
      }).then(res => {
        console.log(res);
        this.item['answerExport'] = res.retValue
        // this.saveAnswer()
        this.extraGroupVisible = false
      })
    },
    async saveExtraQuestionHandler(p) {
      let result = this.$store.dispatch('requestHandler', {
        fn: 'RestNewQuestionnaireDesignCallcenterControllerSaveOptionExtensionAnswerInfo',
        params: {
          optionInfoId: p.optionInfoId,
          followupTaskId: p.followupTaskId,
          followupPatientId: p.followupPatientId,
          answerInfo: p.answerInfo,
        }
      })
      return result
    },
    deleteGroupItemHandler(it, item, index) {
      console.log(it.optionExtraGroupArr, index);
      it.optionExtraGroupArr.splice(index, 1)
      console.log(it.optionExtraGroupArr);
      this.$forceUpdate()
    },
    addOutGroup(it, item) {
      console.log(it);
      let cloneR = _.cloneDeep(it)
      console.log(cloneR);
      let result = cloneR.optionExtraGroupArr[0].arr.map(v => {
        v.value = ""
        return v
      })
      let outResult = cloneR.optionExtraWithOutGroupArr.map(v => {
        v.value = ""
        return v
      })
      item.optionExtra.optionGroupList.push({
        id: item.optionExtra.optionGroupList[item.optionExtra.optionGroupList.length - 1].id + 1,
        optionExtraGroupArr: [{ arr: result , id: 1}],
        optionExtraWithOutGroupArr: outResult
      })
      this.$forceUpdate()
    },
    deleteOutGroup(it, item, ind) {
      item.optionExtra.optionGroupList.splice(ind, 1)
      this.$forceUpdate()
    },
    //添加组列
    addGroupItemHandler(it, inGroup, item) {
      console.log(inGroup);
      if (it.optionExtraGroupArr.length == item.optionExtra.groupTime) {
        this.$message.error('已达到最大限制')
        return
      }
      let clone = _.cloneDeep(inGroup.arr).map(v => {
        v.value = ""
        return v
      })
      console.log(clone);
      it.optionExtraGroupArr.push({
        arr: clone,
        id: it.optionExtraGroupArr[it.optionExtraGroupArr.length - 1].id + 1
      })
      this.$forceUpdate()
    },
    showHandler(item, index,type) {
      this.optionInfoId = item.id
      this.getExtraQuestion({
        optionInfoId: item.id,
        followupTaskId: localStorage.getItem('taskId'),
        followupPatientId: this.patientId,
      }).then(res => {
        if (!res.retValue) {
          console.log(1111);
          item.optionExtra = {extraList: []}
          return
        }
        let arr = JSON.parse(res.retValue)
        item['optionExtra'] = arr
        if(item.optionExtra.contentIds && item.optionExtra.contentIds.length) {
          this.queryQuestionnaireOptionListByTagId({tagIds: item.optionExtra.contentIds})
              .then(res => {
                console.log(res);
                item.contentList = res.retValue
                if (!item.visible && item.hasOwnProperty('optionExtra') && !item.optionExtra.hasOwnProperty('optionExtraGroupArrArr')) {
                  this.item = item
                  if(!type) {
                    this.extraGroupVisible = true
                  }
                } else {
                }
              })
        }
      })


    },
    async getExtraQuestion(p) {
      let result = await this.$store.dispatch('requestHandler', {
        fn: "RestNewQuestionnaireDesignCallcenterControllerQueryContentByOptionId",
        params: {
          optionInfoId: p.optionInfoId,
          followupTaskId: p.followupTaskId,
          followupPatientId: p.followupPatientId,
        }
      })
      return result
    },
    getPicture() {
      if (this.question.pictureUrl && this.question.pictureUrl.indexOf('http') == -1) {
        this.$store.dispatch('getPicture', {url: [this.question.pictureUrl]})
            .then(res => {
              this.question.pictureUrl = res[0]
            })
      }
    },
    selectHandler(item, index) {
      if (item.disabled) {
        return false
      }
      if(item.selected) {
        if(item.answerExport) {
          this.$store.dispatch('requestHandler',{
            fn: 'RestNewQuestionnaireDesignCallcenterControllerDeleteOptionExtensionAnswerInfo',
            params: {
              optionInfoId: item.id,
              followupTaskId: localStorage.getItem('taskId'),
              followupPatientId: this.patientId
            }
          }).then(res => {
            item.answerExport = ""
          })
          item.answerExport = ""
        }
      }
      item.selected = !item.selected

      //判断兼容旧数据
      if (item.isExclusive) {
        if (item.selected) {
          this.question.options.map((_it, _ind) => {
            _it.disabled = true
            _it.selected = false
            this.disabledShowOrHide(_ind, false)
          })
          item.disabled = false
          item.selected = true
        } else {
          this.question.options.map(_it => {
            _it.disabled = false
          })
        }
      } else {
        if (item.exclusiveIds.length > 0) {
          //有排他逻辑
          if (item.selected) {
            //如果有-1
            if (item.exclusiveIds.indexOf(-1) != -1) {
              this.question.options.map((_it, _ind) => {
                _it.disabled = true
                _it.selected = false
                this.disabledShowOrHide(_ind, false)
              })
            } else {
              item.exclusiveIds.forEach(v => {
                // console.log(this.question.options.find(item => item.id == v))
                var it = this.question.options.find(item => item.id == v)
                var ind = this.question.options.findIndex(item => item.id == v)
                it.disabled = true
                it.selected = false
                this.disabledShowOrHide(ind, false)
              })
            }
            item.disabled = false
            item.selected = true
          } else {
            this.question.options.map(_it => {
              _it.disabled = false
            })
          }
        }
      }
      if (this.displaySetting.length) {
        if (item.selected) {
          this.disabledShowOrHide(index + 1, true)
        } else {
          this.disabledShowOrHide(index + 1, false)
          // this.question.options.forEach((v, i) => {
          //   if (v.selected) {
          //     this.disabledShowOrHide(i + 1, true)
          //   }
          // })
        }
      }
      this.question.value = this.QsValue
      // this.saveAnswer()

    },
    // disabledShowOrHide(index, boolean) {
    //     var disabledList = this.displaySetting.filter(item => item.optionId == index).map(it => {
    //         return it.questionId
    //     })
    //     disabledList.forEach(v => {
    //         if (this.questionList.find(item => item.id == v)) {
    //             this.questionList.find(item => item.id == v).isShow = boolean
    //         }
    //     })
    // },
    disabledShowOrHide(index, boolean) {
      // console.log(index)
      var disabledList = this.displaySetting.filter(item => item.optionId == index).map(it => {
        return it.questionId
      }).flat(9) //平铺数组 兼容处理
      if (disabledList) {
        disabledList.forEach(v => {
          // console.log(v)
          if (this.questionList.find(item => item.id == v)) {
            this.questionList.find(item => item.id == v).isShow = boolean
          }
        })
      }
    },
    checkIsFill() {
      if (this.question.isShow) {
        if (this.question.isMust) {
          if (this.QsValue.length) {
            return true
          } else {
            return false
          }
        } else {
          return true
        }
      } else {
        return true
      }
    },
    getAnswer() {
      this.displaySetting.map(item => {
        if (item.newOptionId) {
          item.optionId = this.question.options.findIndex(_it => _it.id == item.newOptionId) + 1
          return item
        }
      })
      if (this.question.value && this.question.value != "") {
        this.question.value.forEach((v, i) => {
          var optionIndex = this.question.options.findIndex(item => item.id == v.id)
          this.question.options[optionIndex] = v
          this.question.options[optionIndex].selected = true
          this.question.options[optionIndex].yearSelect = v.yearSelect
          this.question.options[optionIndex].monthSelect = v.monthSelect
          this.question.options[optionIndex].daySelect = v.daySelect
          if (this.question.options[optionIndex].isExclusive) {
            if (this.question.options[optionIndex].selected) {
              this.question.options.map((_it, _ind) => {
                _it.disabled = true
                _it.selected = false
                this.disabledShowOrHide(_ind, false)
              })
              this.question.options[optionIndex].disabled = false
              this.question.options[optionIndex].selected = true
            } else {
              this.question.options.map(_it => {
                _it.disabled = false
              })
            }
          } else {
            if (this.question.options[optionIndex].exclusiveIds.length > 0) {
              //有排他逻辑
              if (this.question.options[optionIndex].selected) {
                //如果有-1
                if (this.question.options[optionIndex].exclusiveIds.indexOf(-1) != -1) {
                  this.question.options.map((_it, _ind) => {
                    _it.disabled = true
                    _it.selected = false
                    this.disabledShowOrHide(_ind, false)
                  })
                } else {
                  this.question.options[optionIndex].exclusiveIds.forEach(v => {
                    // console.log(this.question.options.find(this.question.options[optionIndex] => this.question.options[optionIndex].id == v))
                    // var it = this.question.options.find(v => this.question.options[optionIndex].id == v)
                    // var ind = this.question.options.findIndex(v => this.question.options[optionIndex].id == v)
                    var it = this.question.options.find(item => item.id == v)
                    var ind = this.question.options.findIndex(item => item.id == v)
                    it.disabled = true
                    it.selected = false
                    this.disabledShowOrHide(ind, false)
                  })
                }
                this.question.options[optionIndex].disabled = false
                this.question.options[optionIndex].selected = true
              } else {
                this.question.options.map(_it => {
                  _it.disabled = false
                })
              }
            }
          }
          this.disabledShowOrHide(optionIndex + 1, true)
        })
        this.show = true
      }
    },
    saveAnswer() {
      this.loading = true
      return new Promise(resolve => {
        var params = {
          operatorId: localStorage.getItem('huidrUserId'),
          questionInfo: this.question.id,
          questionnaireNewId: this.question.questionnaireNewId,
          answerInfo: JSON.stringify(this.QsValue),
          id: this.question.patientAnswerInfoId || null,
          patientId: this.patientId,
          questionType: this.question.type || null,
        }
        if (this.$route.query.abnormal == '5') {
          params.isRecord = true
        } else {
          params.isRecord = false
        }
        if (this.question.patientAnswerInfoId) {
          this.$store.dispatch('updateQuestionAnswer', params)
              .then(res => {
                if (res.status == 0) {
                  this.loading = false

                  resolve(true)
                } else {
                  this.$message.error('请检查网络连接')
                  this.loading = false
                  resolve(false)
                }
              })
        } else {
          this.$store.dispatch('saveQuestionAnswer', params)
              .then((res) => {
                //console.log(res);
                // this.question.patientAnswerInfoId = res.retValue.id
                if (res.status == 0) {
                  this.question.patientAnswerInfoId = res.retValue.id
                  this.loading = false

                  resolve(true)
                } else {
                  this.$message.error('请检查网络连接')
                  this.loading = false
                  resolve(false)
                }
              })
        }
        console.log(params)
      })
      // this.$store.dispatch('saveQuestionAnswer',)
    },
    deleteAnswer() {
      var params = {
        questionNewId: this.question.questionnaireNewId,
        answerInfoId: this.question.patientAnswerInfoId || null,
      }
      if (this.question.patientAnswerInfoId) {
        this.$store.dispatch('deleteQuestionAnswer', params)
            .then(res => {
              if (res.status == 0) {
                this.question.patientAnswerInfoId = null
                this.question.value = null
                this.question.answerInfo = null
                this.question.options.forEach(item => {
                  item.selected = false
                })
              } else {
              }
            })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "questionCommon";

.option-container {
  &.flex {
    display: flex;
    flex-wrap: wrap;
  }

  .question-option {
    &.two {
      width: 50%;
    }

    &.three {
      width: 30%;
    }

    .option-title {
      display: flex;
      align-items: center;
      justify-content: flex-start;

      .optionTitle {
        width: 100%;
        text-align: left;
        font-size: 16px;
        margin-left: 10px;
        word-wrap: break-word;
        word-break: break-all;
      }

      .disabled {
        color: #ccc;
      }

      span {
        font-size: 16px;
        margin-left: 10px;
      }
    }

    .option-other {
      .fill-content {
        width: 180%;
        border: 1px solid #d8d8d8;
      }
    }
  }

}
.extra-content {
  max-height: 500px;
  overflow: auto;
}

.extra-content-inner {
  padding: 10px;
  display: flex;
  margin-bottom: 10px;
  align-items: center;
  flex-wrap: wrap;
  border-bottom: 1px dashed #ccc;

  .extra-content-inner-item {
    padding: 5px 0px;
    margin-right: 10px;
  }

  i {
    margin-right: 10px;
  }
}

.el-icon-edit {
  padding: 3px;
  margin-left: 5px;
  cursor: pointer;
  color: #248cfa;
}
.yellow {
  color: orange;
}
</style>